import { call, put, takeEvery, all } from "redux-saga/effects";
import * as actionTypes from "../actions/ActionTypes";
import apis from "../../shared/constants/api-url";
import { MSG } from "../../shared/constants/constants";
import signatureV4CreateCanonicalRequest, {
  createRequestBody
} from "../../shared/components/sigv4Client";
import { getTemporaryCredentials } from "../../shared/components/SignApi";
import { appAuthencationCheck } from "../../../modules/appAuthencationCheck";

// get All email Document list
function* fetchEmailConfigurationList(action) {
  const { payload } = action;
  const practiceId = payload;
  try {
    const params = {
      offset: "",
      limit: "10000"
    };
    console.log("This One ");
    const requestBody = createRequestBody(
      "get",
      `/practices/email/configure/getAllPracticeEmailConfiguration/${practiceId}`,
      params,
      ""
    );
    const request = signatureV4CreateCanonicalRequest(requestBody, getTemporaryCredentials());
    const response = yield call(() => apis(request));
    yield put({
      type: actionTypes.EMAIL_CONFIGURATION_LIST_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    if (appAuthencationCheck(error) === true) {
      yield put({
        type: actionTypes.EMAIL_CONFIGURATION_LIST_FAIL,
        message: error.message
      });
    }
  }
}

function* fetchEmailConfigurationSaga() {
  yield takeEvery(actionTypes.EMAIL_CONFIGURATION_LIST_REQUESTED, fetchEmailConfigurationList);
}

// add Email Doc
function* addEmailConfiguration(action) {
  const { payload } = action;
  console.log(payload, ">>>>>> payload");
  const body = {
    practiceId: payload.practiceId,
    emailTemplateId: payload.emailTemplateId,
    isActive: payload.isActive,
    followUpDays: payload.followUpDays,
    isFollowUpEmail: payload.isFollowUpEmail,
    emailType: payload.emailType,
    createdBy: payload.createdBy,
    updatedBy: payload.updatedBy
  };
  try {
    const requestBody = createRequestBody("post", `/practices/email/configure/create`, "", body);
    const request = signatureV4CreateCanonicalRequest(requestBody, getTemporaryCredentials());
    const response = yield call(() => apis(request));
    yield put({
      type: actionTypes.ADD_EMAIL_CONFIGURATION_SUCCESS,
      payload: response.data,
      successMsg: MSG.SAVED_SUCCESSFULLY
    });
  } catch (err) {
    if (appAuthencationCheck(err) === true) {
      yield put({
        type: actionTypes.ADD_EMAIL_CONFIGURATION_FAILED,
        message: err.response.data
      });
    }
  }
}

function* addEmailConfigurationSaga() {
  yield takeEvery(actionTypes.ADD_EMAIL_CONFIGURATION_REQUESTED, addEmailConfiguration);
}

// Edit Email Doc
function* editEmailConfiguration(action) {
  const { payload } = action;
  const body = {
    practiceId: payload.practiceId,
    emailTemplateId: payload.emailTemplateId,
    isActive: payload.isActive,
    followUpDays: payload.followUpDays,
    isFollowUpEmail: payload.isFollowUpEmail,
    emailType: payload.emailType,
    createdBy: payload.createdBy,
    updatedBy: payload.updatedBy,
    practiceEmailMappingId: payload.practiceEmailMappingId
  };
  try {
    const requestBody = createRequestBody("put", `/practices/email/configure/update`, "", body);
    const request = signatureV4CreateCanonicalRequest(requestBody, getTemporaryCredentials());
    const response = yield call(() => apis(request));

    yield put({
      type: actionTypes.EDIT_EMAIL_CONFIGURATION_SUCCESS,
      payload: response.data,
      successMsg: MSG.UPDATED_SUCCESSFULLY
    });
  } catch (err) {
    if (appAuthencationCheck(err) === true) {
      yield put({
        type: actionTypes.EDIT_EMAIL_CONFIGURATION_FAILED,
        message: err.response.data
      });
    }
  }
}

function* editEmailConfigurationSaga() {
  yield takeEvery(actionTypes.EDIT_EMAIL_CONFIGURATION_REQUESTED, editEmailConfiguration);
}

// Delete Email Conf
function* deleteEmailConfiguration(action) {
  const { payload } = action;

  try {
    const requestBody = createRequestBody(
      "delete",
      `/practices/email/configure/delete/${payload.practiceEmailMappingId}`,
      "",
      ""
    );
    const request = signatureV4CreateCanonicalRequest(requestBody, getTemporaryCredentials());
    const response = yield call(() => apis(request));

    yield put({
      type: actionTypes.DELETE_EMAIL_CONFIGURATION_SUCCESS,
      payload: response,
      successMsg: "Configuration Deleted"
    });
  } catch (err) {
    if (appAuthencationCheck(err) === true) {
      yield put({
        type: actionTypes.DELETE_EMAIL_CONFIGURATION_FAILED,
        message: err.response.data
      });
    }
  }
}

function* deleteEmailConfigurationSaga() {
  yield takeEvery(actionTypes.DELETE_EMAIL_CONFIGURATION, deleteEmailConfiguration);
}

export default function* emailConfigurationSaga() {
  yield all([
    fetchEmailConfigurationSaga(),
    addEmailConfigurationSaga(),
    editEmailConfigurationSaga(),
    deleteEmailConfigurationSaga()
  ]);
}
